export const menuItems = [
    {
        label: "Dashboard",
        icon: "mdi mdi-apps",
        link: "/",
        perm: "view_dashboard",
    },
    {
        label: "Members",
        icon: "mdi mdi-account-multiple-plus",
        perm: "view_members",
        subItems: [
            {
                label: "Member Accounts",
                link: "/viewmembers",
                perm: "view_members",
            },
            // {
            //     label: "Applicants",
            //     link: "/applicants",
            //     perm: "view_applicants",
            // },
            {
                label: "Membership Fees",
                link: "/membershipfees",
                perm: "view_membershipfees",
            },
            {
                label: "Registration Fees",
                link: "/registrationfees",
                perm: "view_membershipfees",
            },
            {
                label: "Passbook Fees",
                link: "/passbookfees",
                perm: "view_membershipfees",
            },
            {
                label: "Software Subscriptions",
                link: "/subscriptionfees",
                perm: "view_membershipfees",
            },
            {
                label: "Accounts Balances",
                link: "/account_balances",
                perm: "view_balances",
            },
        ],
    },
    {
        label: "Savings",
        icon: "mdi mdi-cash-multiple",
        perm: "view_savings",
        subItems: [
            {
                label: "Savings",
                link: "/savings",
                perm: "view_savings",
            },
            {
                label: "Shares",
                link: "/shares",
                perm: "view_shares",
            },
            {
                label: "Withdraws",
                link: "/withdraws",
                perm: "view_withdraws",
            },
            {
                label: "Withdraw Charges",
                link: "/withdrawcharges",
                perm: "view_withdraw_charges",
            },
        ],
    },
    {
        label: "Loans",
        icon: "mdi mdi-cash",
        perm: "view_loans",
        subItems: [
            {
                label: "Loan Application",
                link: "/applications",
                perm: "view_loanapplications",
            },
            {
                label: "Loan Disbursement",
                link: "/disbursements",
                perm: "view_loandisbursement",
            },
            {
                label: "Running Loans",
                link: "/runningloans",
                perm: "view_runningloans",
            },
            {
                label: "Closed Loans",
                link: "/closedloans",
                perm: "view_closedloans",
            },
            {
                label: "Loan Arrears",
                link: "/loanarrears",
                perm: "view_loanarrears",
            },
            {
                label: "Loan Charges",
                link: "/loancharges",
                perm: "view_loan_charges",
            },
            {
                label: "Loan Products",
                link: "/loantypes",
                perm: "view_loan_products",
            },
        ],
    },
    {
        label: "Credit Score",
        // icon: "mdi mdi-new-box",
        icon: "mdi mdi-gauge",
        perm: "view_loanapplications",
        subItems: [
            {
                label: "Calculator",
                link: "/credit-score",
                perm: "view_loanapplications",
            },
            {
                label: "Credit Reports",
                link: "/credit-reports",
                perm: "view_loanapplications",
            },
        ],
    },
    // {
    //     label: "Checkoff List",
    //     icon: "mdi mdi-check-underline",
    //     perm: "view_dashboard",
    //     subItems: [
    //         {
    //             label: "New Checkoff",
    //             link: "/new-checkoff-list",
    //             perm: "view_dashboard",
    //         },
    //         {
    //             label: "Past Checkoffs",
    //             link: "/checkoff-lists",
    //             perm: "view_dashboard",
    //         },
    //         // {
    //         //     label: "Deduction Requets",
    //         //     link: "/deduction-requests",
    //         //     perm: "view_expense_items",
    //         // },
    //     ],
    // },
    {
        label: "Returns",
        icon: "mdi mdi-clipboard-list",
        perm: "view_returns",
        subItems: [
            {
                label: "Investments Returns",
                link: "/investmentreturns",
                perm: "view_investment_returns",
            },
            {
                label: "Investments",
                link: "/investments",
                perm: "view_investment",
            },
            {
                label: "Member Interests",
                link: "/memberinterests",
                perm: "member_interests",
            },
            {
                label: "Interests Payouts",
                link: "/interestpayouts",
                perm: "interest_payouts",
            },
            {
                label: "ShareHolder Dividends",
                link: "/shareholderdividends",
                perm: "share_holder_dividends",
            },
            {
                label: "Dividend Payouts",
                link: "/dividendpayouts",
                perm: "dividend_payouts",
            },
        ],
    },
    {
        label: "Welfare",
        icon: "mdi mdi-hand-heart",
        // icon: "mdi mdi-new-box",
        perm: "view_dashboard",
        subItems: [
            {
                label: "Contributions",
                link: "/contributions",
                perm: "view_dashboard",
            },
            {
                label: "Give Away",
                link: "/give-away",
                perm: "view_dashboard",
            },
            {
                label: "Donations",
                link: "/donations",
                perm: "view_dashboard",
            },
        ],
    },
    {
        label: "Expenses",
        icon: "mdi mdi-database",
        perm: "view_expenses",
        subItems: [
            {
                label: "Record Expense",
                link: "/recordexpense",
                perm: "record_expenses",
            },
            {
                label: "View Expenses",
                link: "/viewexpenses",
                perm: "recorded_expenses",
            },
            {
                label: "Expense Items",
                link: "/expenseitems",
                perm: "view_expense_items",
            },
            {
                label: "Expense Categories",
                link: "/expensecategories",
                perm: "view_expense_categories",
            },
        ],
    },
    {
        label: "Settings",
        icon: "mdi mdi-cog",
        perm: "view_settings",
        subItems: [
            {
                label: "System Users",
                link: "/users",
                perm: "view_system_users",
            },
            {
                label: "System Roles",
                link: "/roles",
                perm: "view_system_roles",
            },
            {
                label: "System Permissions",
                link: "/permissions",
                perm: "system_permissions",
            },
            {
                label: "Payment Options",
                link: "/paymentoptions",
                perm: "view_payment_options",
            },
            {
                label: "Saving Packages",
                link: "/savingpackages",
                perm: "view_saving_packages",
            },
            {
                label: "Financial Years",
                link: "/financialyears",
                perm: "view_financial_years",
            },
            {
                label: "Audit Trails",
                link: "/audits",
                perm: "view_audit_trails",
            },
            {
                label: "Company Settings",
                link: "/settings",
                perm: "view_settings",
            },
            {
                label: "Company Profile",
                link: "/profile",
                perm: "view_company_profile",
            },
        ],
    },
];
